module.exports = __webpack_public_path__ + "static/img/bg.46dd90e0.png";